import { Button } from '@ui/components/button'
import InputText from '@ui/components/input-text/input-text.component.tsx'
//import {
//	UploadError,
//	useUpload,
//} from '@ui/modal-views/hooks/use-upload.hook.ts'
import React, { useRef } from 'react'
//import LoaderComponent from '@ui/components/loader/loader.component.tsx'
import { isDeviceMobile } from '@utils/mobile.ts'
//import { MobileUploadPage } from '@ui/pages/mobile-upload/mobile-upload.page.tsx'
//import { UserDocument } from '@hooks/use-ocr.hooks.ts'
import { useModUnico } from '@hooks/use-mod-unico.hook'
import { useSetAtom } from 'jotai'
import { modalShowHeader } from '@store/atoms'
import { EXT_ALLOWED } from '@utils/validators'
import { useUpload, type UploadError } from './hooks/use-upload.hook'
import type { UserDocument } from '@hooks/use-ocr.hooks'
import { MobileUploadPage } from '../../mobile-upload/mobile-upload.page'


type FileComponentProps = {
	file: File
	removeFile: (name: string) => void
}

const File: React.FC<FileComponentProps> = ({ file, removeFile }) => {
	return (
		<div className={'carta-id__file'}>
			<a
				className={'carta-id__file--name'}
				href={window.URL.createObjectURL(file)}
				target='_blank'
			>
				{file.name}
			</a>
			<p
				className={'carta-id__file--remove'}
				onClick={() => removeFile(file.name)}
			>
				x
			</p>
		</div>
	)
}

type FileUploadComponentProps = {
	title: string
	id: UserDocument
	minDocs?: number
	maxDocs?: number
}

export const FileUploadErrorComponent: React.FC<
	UploadError & {
		id: UserDocument
		reset: () => void
		closeModal: () => void
	}
> = ({ title, description, reset, closeModal }) => (
	<>
		<img
			className={'carta-id__container--img'}
			src={'/assets/images/esclamativo.png'}
		/>
		<p className={'carta-id__container--title'}>{title}</p>
		<div>
			<p>{description}</p>
		</div>
		<div className={'carta-id__container--btnsgrp'}>
			<Button
				label={'riprova'}
				className={'carta-id__container-btn'}
				onClick={() => reset()}
			/>
			<Button
				label={'cambia modalità'}
				className={'carta-id__container-btn'}
				onClick={closeModal}
			/>
		</div>
	</>
)

const FileUploadDesktopComponent: React.FC<FileUploadComponentProps> = ({
	title,
	id,
	minDocs = 2,
	maxDocs = 2,
}) => {
	const {
		files,
		updateFiles,
		removeFile,
		showLoader,
		uploadFiles,
		hasError,
		resetFiles,
		canGoFurther,
		closeModal,
	} = useUpload(id, maxDocs, minDocs)

	const labelUnico = useModUnico()

	const inputRef = useRef<HTMLInputElement>(null)
	const useHideModalHeader = useSetAtom(modalShowHeader)

	useHideModalHeader(hasError.type === 'NONE' && !showLoader)

	const enableNext = () => {
		if ((files?.length || 0) >= minDocs) {
			uploadFiles()
		}
	}

	return (
		<div className={'carta-id__container'}>
			{showLoader ? (
				<div className={'carta-id__container--loader'}>
					{/* <LoaderComponent force /> */}
				</div>
			) : (
				<>
					{hasError.type !== 'NONE' ? (
						<FileUploadErrorComponent
							type={hasError.type}
							title={hasError.title}
							description={hasError.description}
							id={id}
							reset={resetFiles}
							closeModal={closeModal}
						/>
					) : (
						<>
							<p className={'carta-id__container--title'}>
								Carica i tuoi documenti
							</p>
							<div>
								<p>
									Per proseguire allega una copia fronte e retro dei documenti
									in formato{' '}
									<span className={'carta-id__container--bold'}>
										JPG, PNG, TIFF, HEIC/HEIF o PDF
									</span>{' '}
									di{' '}
									<span className={'carta-id__container--bold'}>
										dimensione non superiore a 5MB.
									</span>
								</p>
								<p>
									I documenti devono essere chiaramente leggibili e non devono
									contenere riflessi.
								</p>
							</div>
							<InputText
								label={id === 'ALTRO' ? labelUnico : title}
								type={'file'}
								ref={inputRef}
								buttonLabel={'Allega'}
								onButtonClick={() => {
									inputRef.current?.click()
								}}
								className={'carta-id__upload'}
								onChange={(e) => updateFiles(e.target.files)}
								multiple
								accept={EXT_ALLOWED.join(',')}
							/>
							<div className={'carta-id__container--list'}>
								{!showLoader &&
									files?.map((file, idx) => (
										<File file={file} removeFile={removeFile} key={idx} />
									))}
							</div>
							<Button
								label={'procedi'}
								className={'carta-id__container-btn'}
								disabled={!canGoFurther}
								onClick={enableNext}
							/>
						</>
					)}
				</>
			)}
		</div>
	)
}

const FileUploadComponent: React.FC<FileUploadComponentProps> = (props) => {
	const isMobile = isDeviceMobile()

	return isMobile ? (
		<MobileUploadPage isOnMobile={false} />
	) : (
		<FileUploadDesktopComponent {...props} />
	)
}

export { FileUploadComponent }
